// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1___6897b915e676fd04c59","cls2":"UserTooltip-cls2___1b44bc41ffc108ed857 UserTooltip-cls1___6897b915e676fd04c59"};